import Marty from "marty";
import USER_CONSTANTS from "../constants/userConstants";
import getFormErrors from "../utils/functions/getFormErrors";

let userActions = Marty.createActionCreators({
    cancelOrder(data, reset, invalidate) {
        this.dispatch(USER_CONSTANTS.CANCEL_ORDER);
        return this.app.userAPI.cancelOrder(data).then(res => {
            this.dispatch(USER_CONSTANTS.CANCEL_ORDER_DONE, res.data);
            reset();
        }).catch(err => {
            this.dispatch(USER_CONSTANTS.CANCEL_ORDER_FAILED, err);
            invalidate(getFormErrors(err.data));
        });
    }
});

export default userActions;



/** WEBPACK FOOTER **
 ** ./app/actions/userActions.js
 **/